"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchGroupDrawableTypesSchema = void 0;
const zod_1 = require("zod");
const Bus_1 = require("./Bus");
const Circle_1 = require("./Circle");
const Polygon_1 = require("./Polygon");
const TextBox_1 = require("./TextBox");
const Junction_1 = require("./Junction");
const Label_1 = require("./Label");
const Rect_1 = require("./Rect");
const Segment_1 = require("./Segment");
const Text_1 = require("./Text");
const Track_1 = require("./Track");
const Image_1 = require("./Image");
exports.SchGroupDrawableTypesSchema = zod_1.z.discriminatedUnion('type', [
    Bus_1.BusSchema,
    Circle_1.CircleSchema,
    Image_1.ImageSchema,
    Junction_1.JunctionSchema,
    Label_1.LabelSchema,
    Polygon_1.PolygonSchema,
    Segment_1.SegmentSchema,
    Rect_1.RectSchema,
    Text_1.TextSchema,
    Track_1.TrackSchema,
    TextBox_1.TextBoxSchema,
]);
//# sourceMappingURL=SchGroupDrawableTypes.js.map